import React from 'react';
import "../style/components/_pageTopBanner.scss";

const PageTopBanner = ({ img, title, info }) => {
    return (
        // test
        <div className="page-banner">
            <img className="banner-img" src={img} alt="" />

            <section className="page-intro">
                <div className="page-title">
                    <h1>{title}</h1>
                </div>
                <p className="page-info_text">{info}</p>
            </section>
        </div>
    );
};

export default PageTopBanner;